import { render, staticRenderFns } from "./DownloadOthers.vue?vue&type=template&id=cf4d4458&scoped=true"
import script from "./DownloadOthers.vue?vue&type=script&lang=ts"
export * from "./DownloadOthers.vue?vue&type=script&lang=ts"
import style0 from "./DownloadOthers.vue?vue&type=style&index=0&id=cf4d4458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4d4458",
  null
  
)

export default component.exports